import React from 'react';
import Panel from '../../../components/Panel.jsx';

import {
    useIsExporting
} from '../../../hooks/useExport.js';

import {
    useCurationConfigValue
} from '../../../hooks/widgetConfiguration.js';

import {
    useLoadLandscapeListeningQuery
} from '../hooks/useListeningQueryPersistence.js';

export default function PanelWithUpsell(props) {
    const listeningQueryId = useCurationConfigValue('listeningQueryId');
    const {data: listeningQuery} = useLoadLandscapeListeningQuery(listeningQueryId);
    const isSampleTopic = Boolean(listeningQuery?.isSampleTopic);

    const plan = useCurationConfigValue('plan');
    const isTrial = plan.kind === 'trial';

    const hasFullInstantSearch = plan.has_full_instant_search;
    const isExporting = useIsExporting();

    if (!isSampleTopic && !hasFullInstantSearch && !props.allowedWithoutFullInstantSearch) {
        if (isExporting) {
            return null;
        }

        return (
            <Panel
                instanceId={props.instanceId}
                title={props.title}
                description={props.description}
                showViewMore={false}
                isExportable={false}
            >
                <div className='tlw-flex tlw-h-full tlw-min-h-[100px] tlw-grow tlw-flex-col tlw-items-center tlw-justify-center tlw-text-[36px] tlw-text-gray-500'>
                    <h3
                        className='tlw-m-0 tlw-max-h-[43px] tlw-overflow-hidden tlw-text-ellipsis tlw-whitespace-nowrap tlw-text-base tlw-leading-22 tlw-text-gray-900'
                    >
                        {isTrial ? 'Purchase' : 'Upgrade'} to unlock Social Listening insights
                    </h3>

                    <span
                        className='tlw-text-sm tlw-font-normal tlw-text-gray-700'
                    >
                        The {props.title} panel is not available in your {isTrial ? 'trial' : 'plan'}.
                    </span>
                </div>
            </Panel>
        );
    }

    return React.createElement(Panel, props);
}
